import request from '@/axios'

// 客户跟进复盘列表
export function getBehavingReviewList(data) {
  return request({
    url: '/inside/customerReview/getBehavingReviewList',
    data
  })
}

// 获取线索模板列表
export function getClueTemplateList(data) {
  return request({
    url: '/inside/ai/commonFilter/getClueTemplateList',
    data
  })
}

// 获取线索来源列表
export function getClueSourceList(data) {
  return request({
    url: '/inside/ai/commonFilter/getClueSourceList',
    data
  })
}

// 获取指定线索阶段的跟进线索列表
export function getClueFollowUpList(data) {
  return request({
    url: '/inside/review/clue/laneView',
    data
  })
}

// 获取线索阶段版本列表
export function getClueStageVersionList(data) {
  return request({
    url: '/inside/review/clue/getLaneViewVersionList',
    data
  })
}

// 获取线索阶段列表
export function getClueStageList(data) {
  return request({
    url: '/inside/review/clue/getClueStage',
    data
  })
}

// 获取部门列表
export function getDepartmentlist(data) {
  return request({
    url: '/inside/meetingOverview/department/list',
    data
  })
}

// 客户跟进复盘详情
export function getBehavingReviewDetail(data) {
  return request({
    url: '/inside/customerReview/getBehavingReviewDetail',
    data
  })
}

// 线索跟进复盘详情
export function getClueBehavingReviewDetail(data) {
  return request({
    url: '/inside/clueReview/getClueBehavingReviewDetail',
    data
  })
}

// 商机跟进复盘详情
export function getBehavingReviewDetailOpportunity(data) {
  return request({
    url: '/inside/opportunityReview/getBehavingReviewDetail',
    data
  })
}

// 客户跟进复盘详情
export function getBehavingDetail(data) {
  return request({
    url: '/inside/customerReview/getBehavingDetail',
    data
  })
}

// 跟进拜访人员列表
export function geuUserList(data) {
  return request({
    url: '/inside/meetingOverview/user/list',
    data
  })
}

// 跟进指标统计
export function getStatistics(data) {
  return request({
    url: '/inside/meetingOverview/statistics',
    data
  })
}

// 跟进拜访排名
export function getRankList(data) {
  return request({
    url: '/inside/meetingOverview/rank',
    data
  })
}

// 客户下拉选项
export function getCustomerOption(data) {
  return request({
    url: '/inside/customerReview/getCustomerOption',
    data
  })
}

// 客户下拉选项 - 需要先选客户模版
export function getCustomerList(data) {
  return request({
    url: '/inside/ai/commonFilter/getCustomerList',
    data
  })
}

// 客户阶段下拉选项 - 需要先选客户模版
export function getCustomerStage(data) {
  return request({
    url: '/inside/review/getCustomerStage',
    data
  })
}

// 会话质量列表
export function getQualityList(data) {
  return request({
    url: '/inside/meetingOverview/quality/list',
    data
  })
}

// 会话质量列表-更多
export function getQualityListMore(data) {
  return request({
    url: '/inside/meetingOverview/quality/list/more',
    data
  })
}

// 加载更多会话跟进行为信息列表
export function getBehavingListMore(data) {
  return request({
    url: '/inside/customerReview/getBehavingList',
    data
  })
}

// 加载更多
export function getBehavingListMoreOpportunity(data) {
  return request({
    url: '/inside/opportunityReview/getBehavingList',
    data
  })
}

// 获取会话看板配置
export function getConfig(data) {
  return request({
    url: '/aiAgent/config/get',
    data
  })
}

// 会话用量详情
export function getUsageStatistics(data) {
  return request({
    url: '/inside/ai/chat/getUsageStatistics',
    data
  })
}

// 会话用量详情
export function getTransactionList(data) {
  return request({
    url: '/inside/transaction/list',
    data
  })
}
// 获取找客助手用量详情
export function getAntUsageList(data) {
  return request({
    url: '/inside/ant/usage/list',
    data
  })
}

// 账单明细列表
export function getTransactionDetailList(data) {
  return request({
    url: '/inside/transaction/detail/list',
    data
  })
}

// 跟进提炼规则列表
export function getRuleList(data) {
  return request({
    url: '/inside/ai/communicateRule/getSummaryRuleList',
    data
  })
}

// 跟进提炼规则详情
export function getRuleDetail(data) {
  return request({
    url: '/inside/ai/communicateRule/getSummaryRuleDetail',
    data
  })
}

// 跟进提炼规则启用
export function enableRule(data) {
  return request({
    url: '/inside/ai/communicateRule/enableSummaryRule',
    data
  })
}

// 跟进提炼规则删除
export function ruleDelete(data) {
  return request({
    url: '/inside/ai/communicateRule/deleteSummaryRule',
    data
  })
}

// 跟进提炼规则保存
export function ruleSave(data) {
  return request({
    url: '/inside/ai/communicateRule/saveSummaryRule',
    data
  })
}
// 获取标杆客户红绿灯数据
export function getCustomerRedLight(data) {
  return request({
    url: '/inside/ai/customerAsset/getCustomerRedLight',
    data
  })
}

// 会话详情页客户详情
export function getCustomerDetail(data) {
  return request({
    url: '/inside/customerReview/customer/detail/get',
    data
  })
}

// 质量分析：保存人工校验结果
export function saveManualVerificationInfo(data) {
  return request({
    url: '/inside/ai/manualVerification/analyze',
    data
  })
}

// 复制提炼规则
export function copySummaryRule(data) {
  return request({
    url: '/inside/ai/communicateRule/copySummaryRule',
    data
  })
}

//排序呼叫中心规则
export function sortSummaryRule(data) {
  return request({
    url: '/inside/ai/communicateRule/sortSummaryRule',
    data
  })
}

// 商机阶段
export function getOpportunityStage(data) {
  return request({
    url: '/inside/opportunityReview/getOpportunityStage',
    data
  })
}

// 商机阶段列表
export function getOpportunityStageList(data) {
  return request({
    url: '/inside/opportunityReview/getOpportunityStage/list',
    data
  })
}

// 商机下拉选项
export function getOpportunityOption(data) {
  return request({
    url: '/inside/opportunityReview/getOpportunityOption',
    data
  })
}

// 机会看板列表
export function getOpportunityReviewList(data) {
  return request({
    url: '/inside/opportunityReview/getBehavingReviewList',
    data
  })
}

// 获取金额视图设置按钮
export function getButton(data) {
  return request({
    url: '/inside/opportunityReview/getButton',
    data
  })
}

// 获取金额视图设置
export function getSetting(data) {
  return request({
    url: '/inside/opportunityReview/getSetting',
    data
  })
}

// 保存金额视图设置
export function saveSetting(data) {
  return request({
    url: '/inside/opportunityReview/saveSetting',
    data
  })
}

// 金额视图列表
export function getAmountReviewList(data) {
  return request({
    url: '/inside/opportunityReview/getAmountReviewList',
    data
  })
}

// 机会看板表单模板
export function getOpportunityForm(data) {
  return request({
    url: '/inside/opportunityReview/getOpportunityForm',
    data
  })
}

// 获取客户模版接口
export function getCustomerTemplateList(data) {
  return request({
    url: '/inside/ai/commonFilter/getCustomerTemplateList',
    data
  })
}

// 获取模版阶段版本接口
export function getStageVersion(data) {
  return request({
    url: '/inside/review/getLaneViewVersionList',
    data
  })
}

// 员工跟进日常
export function getScheduleList(data) {
  return request({
    url: '/inside/userFollow/getScheduleList',
    data
  })
}

// 获取泳道视图
export function getLaneView(data) {
  return request({
    url: '/inside/review/laneView',
    data
  })
}

// 获取已开启的数据来源
export function getSource() {
  return request({
    url: '/inside/customerReview/getSource'
  })
}

// 获取会话存档数据的参数
export function getSessionArchiveParams(data) {
  return request({
    url: '/inside/customerReview/msg/getDialogueQueryParam',
    data
  })
}

// 获取历史派发记录
export function getHistoryList(data) {
  return request({
    url: '/inside/learnTask/list',
    data
  })
}

// 获取公司业务介绍
export function getCompanyTrainingIntroduction(data) {
  return request({
    url: '/inside/a1/training/template/get/introduction',
    data
  })
}

// 公司业务介绍保存
export function saveCompanyTrainingIntroduction(data) {
  return request({
    url: '/inside/a1/training/template/save/introduction',
    data
  })
}

// AI陪练分析-白名单使用阿里智能体
export function checkTrainEnableAliApi() {
  return request({
    url: '/inside/learnTask/checkTrainEnableAli'
  })
}

// AI陪练分析--历史陪练记录
export function getPracticeRecordList(data) {
  return request({
    url: '/inside/learnTask/listPracticeRecord',
    data
  })
}

// AI陪练分析--获取陪练背景
export function getPracticeContent(data) {
  return request({
    url: '/inside/learnTask/getPracticeContent',
    data
  })
}

// AI陪练分析--开始陪练拨号
export function startLearningTask(data) {
  return request({
    url: '/inside/learnTask/startLearningTask',
    data
  })
}

// AI陪练分析--确认提交
export function submitLearnTask(data) {
  return request({
    url: '/inside/learnTask/submit',
    data
  })
}

// AI陪练分析--保存
export function saveLearningTask(data) {
  return request({
    url: '/inside/trainingDashboard/createTrainResult',
    data
  })
}

// AI陪练分析--陪练记录详情
export function getPracticeRecordDetail(data) {
  return request({
    url: '/inside/learnTask/getPracticeRecordDetail',
    data
  })
}
// AI陪练分析--陪练记录轮询
export function listenLearningTask(data) {
  return request({
    url: '/inside/task/heartbeat',
    data
  })
}

// AI陪练分析--获取token
export function getTrainAliToken(data) {
  return request({
    url: '/inside/learnTask/getTrainAliToken',
    data
  })
}

// 获取微信对话历史
export function getWechatUrlApi(data) {
  return request({
    url: '/inside/customerReview/getYkWechatRecord',
    data
  })
}

// 蚂蚁找客、标讯助手开通状态
export function getAntStatus(data) {
  return request({
    url: '/inside/ant/open/status',
    data
  })
}

// 蚂蚁找客、标讯助手开通试用
export function openAntTrial(data) {
  return request({
    url: '/inside/ant/open/trial',
    data
  })
}

/**
 * 提示词优化
 * @param {Object} data
 * @param {number} data.sceneType 场景类型：1-分析师，2-跟进分析模板，3-质量分析
 * @param {string} data.userPrompt 用户输入的原始提示词
 * @returns {Promise}
 */
export function optPrompt(data) {
  return request({
    url: '/inside/ai/prompt/optimizePrompt',
    data
  })
}

// 申请留资
export function leaveContactApi(data) {
  return request({
    url: '/aiAgent/access/buttonClick',
    data
  })
}

// 免费开通
export function freeOpenApi(data) {
  return request({
    url: '/inside/access/free/open',
    data
  })
}

// 飞书群聊开通状态
export function getLarkGroupOpenStatus(data) {
  return request({
    url: '/inside/lark/group/openStatus',
    data
  })
}

// 飞书群聊列表
export function getLarkGroupList(data) {
  return request({
    url: '/inside/lark/group/list',
    data
  })
}

// 新建飞书群聊并关联
export function addLarkGroup(data) {
  return request({
    url: '/inside/lark/group/add',
    data
  })
}

// 关联已有飞书群聊
export function bindLarkGroup(data) {
  return request({
    url: '/inside/lark/group/bind',
    data
  })
}

// 解绑飞书群聊
export function unbindLarkGroup(data) {
  return request({
    url: '/inside/lark/group/unbind',
    data
  })
}

// 市场中心用，主要是跳转设置和去使用判断是否有权限
export function marketAuthApi(data) {
  return request({
    url: '/inside/access/permission',
    data
  })
}

// *********************************START 员工陪练PK***********************************
// 查询pk榜排行榜
export function getStaffTrainingPkList(data) {
  return request({
    url: '/inside/ai/trainingPk/rank',
    data
  })
}

// 初始化 PK 榜专项训练筛选项
export function getStaffTrainingPkFilterInit(data) {
  return request({
    url: '/inside/ai/trainingPk/filterInit',
    data
  })
}

// 查询pk榜员工明细
export function getStaffTrainingPkUserDetail(data) {
  return request({
    url: '/inside/ai/trainingPk/userDetail',
    data
  })
}
// 查询pk榜员工明细
export function getThemePracticeTask(data) {
  return request({
    url: '/inside/ai/themePracticeTask/userList',
    data
  })
}
// 查询pk榜看板统计
export function getTrainingPkOverview(data) {
  return request({
    url: '/inside/ai/trainingPk/overview',
    data
  })
}
// ai陪练助手（看板）
export function getLearnTaskOverview(data) {
  return request({
    url: '/inside/learnTask/overview',
    data
  })
}
// 查询专项训练客户画像列表
export function getThemePracticeEmployeeTaskDetail(data) {
  return request({
    url: '/inside/ai/themePracticeTask/employeeTaskDetail',
    data
  })
}
// 开始陪练（专项训练）
export function startPracticeThemePracticeTask(data) {
  return request({
    url: '/inside/ai/themePracticeTask/startPractice',
    data
  })
}
// 查询任务练习情况列表
export function getTrainingReviewTaskList(data) {
  return request({
    url: '/inside/ai/trainingReview/taskList',
    data
  })
}

// 查询任务练习情况详情
export function getTrainingReviewTaskDetail(data) {
  return request({
    url: '/inside/ai/trainingReview/taskDetail',
    data
  })
}
// *********************************END 员工陪练PK***********************************
